import { OfferPageActions, type OfferPageDispatchAction, type OfferPageState, type OfferPageRoom } from './offerPageStateReducer'
import { isFlashHotelOffer } from 'lib/offer/offerTypes'
import { getInitialFlashSameRoomSelection } from 'lib/offer/initialSameRoomSelection'

export type OfferPageRoomsTransitionState = Pick<OfferPageState, 'offer' | 'rooms' | 'duration' | 'multiRoomMode' | 'flashPackageSelectionActive' | 'flashSameRoomSelection'>

/** Decide the Flash selection/count transition before the reducer stores the resulting payload. */
export function setOfferPageRooms(state: OfferPageRoomsTransitionState, requestedRooms: Array<OfferPageRoom>): Extract<OfferPageDispatchAction, { type: OfferPageActions.setRooms }> {
  const offer = state.offer
  if (!state.flashPackageSelectionActive || !isFlashHotelOffer(offer) || state.multiRoomMode !== 'same-room') {
    return { type: OfferPageActions.setRooms, rooms: requestedRooms }
  }
  let rooms = requestedRooms
  let selection = state.flashSameRoomSelection
  if (rooms.length === 1) {
    if (state.rooms.length > 1 && selection?.offerId === offer.id) {
      const pkg = offer.packages.find(candidate => candidate.uniqueKey === selection?.packageKey)
      rooms = rooms.map(room => ({ ...room, roomId: pkg?.id, rateId: pkg?.roomRate.id, optionalBundleIds: undefined }))
    }
    selection = undefined
  } else if (state.rooms.length === 1) {
    selection = getInitialFlashSameRoomSelection(offer, rooms.slice(0, 1), state.duration, 'same-room')
  }
  return { type: OfferPageActions.setRooms, rooms, flashSameRoomSelection: selection }
}
